import React from 'react';

import clsx from 'clsx';
import { createStyles } from "./styles";






var CarrierLogo = function CarrierLogo(_ref) {var _ref$carrier = _ref.carrier,logo = _ref$carrier.logo,name = _ref$carrier.name,styles = _ref.styles;
  var classes = createStyles();
  return /*#__PURE__*/(
    React.createElement("div", { className: clsx(classes.sponsorLogo, styles) }, /*#__PURE__*/
    React.createElement("img", { width: "auto", height: "24rem", src: logo, alt: name })));


};

export default CarrierLogo;
//# sourceMappingURL=index.js.map